import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {
  InlineFilter,
  InlineFilterProps,
} from '../../../features/Filters/InlineFilter/InlineFilter';
import {InlineFilterError} from '../../../features/Filters/InlineFilter/InlineFilterError';
import {InlineFilterLoading} from '../../../features/Filters/InlineFilter/InlineFilterLoading';
import {ResetAllFilters} from '../../../features/Filters/InlineFilter/ResetAllFilters';
import {useSearchPageFiltersSection} from '../hooks/useSearchPageBulkSection';

export const SearchStreamInlineFilters: React.FC<InlineFilterProps> = props => {
  return (
    <DataFetcher
      request={useSearchPageFiltersSection()}
      Error={InlineFilterError}
      Loading={InlineFilterLoading}
      View={viewProps => {
        const appliedFiltersCount = viewProps.appliedFiltersCount;
        const filtersCount = viewProps.filters.length;

        if (!filtersCount && appliedFiltersCount) {
          return <ResetAllFilters appliedFiltersCount={1} />;
        }

        return <InlineFilter showPersonalizedFilters={true} {...viewProps} />;
      }}
      viewProps={props}
    />
  );
};
